import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, ButtonList, DropdownButton, DropdownButtonContext, Select, } from '@dixa/lib-shared-habla';
import classNames from 'classnames';
import { useCallback, useState } from 'react';
import { analytics } from 'app/utils/segment';
import { ListItemHeader } from 'components/settings/components/sections/openingHours/components/listItemHeader/listItemHeader';
import { useScheduleContext } from 'components/settings/components/sections/openingHours/views/schedule/schedule.context';
import { TemplatesModal } from 'components/shared/templatesModal/templatesModal';
import { useListItemContext } from '../../listItem.context';
import styles from '../../listItem.module.scss';
import { OverriddenItem } from '../overriddenItem/overriddenItem';
function getSelectItem({ id, name }) {
    return {
        id,
        name,
    };
}
export const AutoReply = ({ hasConflict, name: propName, openingHours, overrideException, }) => {
    const { auto_reply_template_id, duration, id, name, next_date, opening_hour_type: openingHourType, recurring, } = openingHours;
    const { onAutoReplyChange, onAutoReplyClear, onOverriddenChange } = useListItemContext();
    const onChange = onAutoReplyChange(id);
    const onClear = onAutoReplyClear(id);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const isRegular = openingHourType === 'regular';
    const { autoReply, templates, fetchTemplates } = useScheduleContext();
    const handleOnSelect = useCallback(({ id }) => void onChange(id), [onChange]);
    const handleOnCreate = useCallback(({ name, id }) => {
        analytics.businessHoursScheduleAutoReplyFormSubmitted({
            openingHourType,
        });
        fetchTemplates();
        onChange(id);
    }, [openingHourType, fetchTemplates, onChange]);
    const itemName = propName || name;
    const selectedTemplate = templates.find((template) => template.id == auto_reply_template_id);
    return (_jsxs("div", Object.assign({ className: styles.root }, { children: [overrideException ? (_jsx(OverriddenItem, { openingHours: openingHours, overrideException: overrideException, onChange: () => onOverriddenChange(openingHours) })) : (_jsxs("div", Object.assign({ className: classNames(styles.item, styles.itemAutoReply, {
                    [styles.itemHasConflict]: hasConflict,
                }) }, { children: [_jsx(ListItemHeader, { duration: duration, hasConflict: hasConflict, name: itemName, nextDate: next_date, openingHourType: openingHourType, recurring: recurring }), _jsx(Box, Object.assign({ className: styles.announcementPicker }, { children: _jsx(Select, { dropdownProps: { fixed: true }, items: templates.map(getSelectItem), onSelect: handleOnSelect, placeholder: !isRegular && !!autoReply
                                ? 'None (standard auto-reply)'
                                : 'None', selectedItems: selectedTemplate
                                ? [
                                    getSelectItem({
                                        id: selectedTemplate.id,
                                        name: selectedTemplate.name,
                                    }),
                                ]
                                : undefined, searchable: true }) }))] }))), _jsx(DropdownButton, { buttonProps: { variant: 'tertiary' }, className: styles.dropdownButton, fixed: true, icon: "dots-h", noArrow: true, onToggle: (isOpen) => {
                    if (isOpen) {
                        analytics.businessHoursScheduleAutoReplyOptionsMenuOpened({
                            openingHourType,
                        });
                    }
                }, dropdown: _jsx(DropdownButtonContext.Consumer, { children: ({ toggleDropdown }) => (_jsxs(ButtonList, { children: [_jsx(ButtonList.Item, Object.assign({ onClick: () => {
                                    analytics.businessHoursScheduleAutoReplyOptionsMenuOptionAddClicked({ openingHourType });
                                    toggleDropdown();
                                    setIsModalOpen(true);
                                } }, { children: "Add auto-reply template" })), _jsx(ButtonList.Item, Object.assign({ isDisabled: !auto_reply_template_id, onClick: () => {
                                    analytics.businessHoursScheduleAutoReplyOptionsMenuOptionClearClicked({ openingHourType });
                                    toggleDropdown();
                                    onClear();
                                } }, { children: "Clear" }))] })) }) }), isModalOpen && (_jsx(TemplatesModal, { confirmName: "Save and select", isOpen: true, modalTitle: isRegular
                    ? 'Add template for standard auto-reply'
                    : `Add auto-reply template for ${name}`, onCreate: handleOnCreate, onClose: () => {
                    analytics.businessHoursScheduleAutoReplyFormCancelled({
                        openingHourType,
                    });
                    setIsModalOpen(false);
                }, type: "email_auto_reply", shouldNotifyOnCreate: false }))] })));
};
